import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useHistory  } from 'react-router-dom'
import socket from '../Components/socket'
import { apiRequest } from '../../apiService/allApi'
const Pay = () => {
  const access_token = localStorage.getItem('token')
// BASE URL
 
const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
const nodeMode = process.env.NODE_ENV;
if (nodeMode === "development") {

  var baseUrl = beckendLocalApiUrl;
} else {
  baseUrl = beckendLiveApiUrl;
}
// +++++++++++++++++++++++++++++ 
  const { search } = useLocation()
  const history = useHistory ()
  
  return <div></div>
}

export default Pay
